import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.css";
import "./index.css";
import { store } from "./app/store";
import App from "./App";
import { StudentPrivacyProvider } from "./context/StudentPrivacyContext";
import { OllamaSetupProvider } from "./context/OllamaSetupContext";
import { initProductAnalytics } from "./utils/productAnalytics";

const container = document.getElementById("root");
const root = createRoot(container);

initProductAnalytics();

// Extract app rendering logic for conditional StrictMode
const renderApp = () => (
  <Provider store={store}>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <OllamaSetupProvider>
        <StudentPrivacyProvider>
          <App />
        </StudentPrivacyProvider>
      </OllamaSetupProvider>
    </BrowserRouter>
  </Provider>
);

// Only enable StrictMode in development to avoid double-rendering issues
// StrictMode intentionally double-invokes effects which can cause issues with:
// - OAuth redirect handling (sessionStorage checks run twice)
// - Firebase auth state listeners
// Keep it in development for React warnings, disable in production for stability
root.render(
  process.env.NODE_ENV === 'development'
    ? <React.StrictMode>{renderApp()}</React.StrictMode>
    : renderApp()
);
